import React from 'react'

const HereToHelp = () => {
  return (
    <>
      <div className='footer-section'>
        <h6>Here to help</h6>
        <div className='help-wrapper'>
          <div className='help-section'>
            <p className='help-title'>Emergency</p>
            <p className='help-text'>The 988 Suicide and Crisis Lifeline provides 24/7, confidential support with trained crisis counselors.</p>
            <p className='help-text'>If you or a loved one is in emotional distress or a suicidal crisis, please call or text 988.</p>
          </div>
        </div>
      </div>
      <hr className='footer-divider' />
    </>
  )
}

export default HereToHelp
